<template>
  <v-snackbar v-model="modelCookies" color="white" :timeout="-1">
    <v-row no-gutters="" class="text-color-0">
      <v-col class="v-col-12 v-col-md-9 d-flex align-center justify-start">
        Analisamos suas preferências utilizando cookies e outras tecnologias similares para melhorar nossos produtos e serviços através das estatísticas, oferecendo a você uma melhor experiência. Ao continuar navegando você concorda com a nossa Política de Privacidade.
      </v-col>
      <v-col class="v-col-0 v-col-md-1">
      </v-col>
      <v-col class="v-col-12 v-col-md-2 d-flex align-center justify-end">
        <v-btn @click="fechar()" flat block size="x-large" class="text-color-white mt-2 mt-md-0 cy-cookies-confirm" color="var(--color-two)">ACEITAR E FECHAR</v-btn>
      </v-col>
    </v-row>      
  </v-snackbar>
</template>
<script>
export default {
  name: 'DialogCookies',
  data(){
    return {
      modelCookies: false
    }
  },
  props: {
    model: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    model() {
      this.modelCookies = this.model;
    },
  },
  methods: {
    fechar(){
      localStorage.setItem("cookiesPermission", 1);
      this.modelCookies = false;
    }
  },
  mounted(){
    if(localStorage.getItem('cookiesPermission') != 1){
      this.modelCookies = true;
    }
  }
}
</script>